import { createFileRoute } from '@tanstack/react-router';
import { SegmentLiveScreen } from '@/features/tracking/SegmentLiveScreen.tsx';
import { requireAuth } from '@/features/auth/guard.ts';
import { q } from '@/lib/queries.ts';

export const Route = createFileRoute('/_app/segments/$segmentId')({
  beforeLoad: requireAuth,
  loader: ({ context, params }) => context.queryClient.prefetchQuery(q.segment(params.segmentId)),
  component: SegmentRoute,
});

function SegmentRoute() {
  const { segmentId } = Route.useParams();
  return <SegmentLiveScreen segmentId={segmentId} />;
}
